"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Glp = function () {
    var data = (0, swr_hooks_1.useGLP)().data;
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var t = (0, next_intl_1.useTranslations)('translation');
    if (!isAuth)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        t('glp'),
        " ", data === null || data === void 0 ? void 0 :
        data.glp));
};
exports.default = Glp;
